import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {HttpModule} from '@angular/http';
import {AlertModule} from 'ng2-bootstrap';
import {RouterModule} from '@angular/router';
import {appRoutes} from "./app-routing.module";
import {ToastModule} from 'ng2-toastr/ng2-toastr';
import {NgIdleKeepaliveModule} from '@ng-idle/keepalive';
import {RecaptchaLoaderService, RecaptchaModule} from 'ng2-recaptcha';

import {MomentModule} from 'angular2-moment'
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MaterialModule} from '@angular/material';
import {AppComponent, SafeHtmlPipe} from './app.component';
import {LoginComponent} from './login/login.component';
import {OrderComponent, TableDialogComponent, PayDialogComponent} from './order/order.component';
import {HashLocationStrategy, LocationStrategy} from "@angular/common";
import 'hammerjs';
import {AdminComponent, ConfirmDialog} from './admin/admin.component';
import {DataService} from "./services/data.service";
import {LoginService} from "./services/login.service";
import {EditDivDirective} from "./directives/edit.directive";
import {EditDataService} from "./services/edit-data.service";
import {Guard} from "./Guard";
import {AdminLogin} from "./admin/adminLogin.component";
import {AdminService} from "./services/adminLogin.service";
import {EditDivDirectiveFooter} from "./directives/edit.footer.directive";
import {paymentSuccess} from "./payment/paymentSuccess.component";
import {paymentFailure} from "./payment/paymentFailure.component";
import {FlexLayoutModule} from "@angular/flex-layout";
import {FooterComponent} from "./footer/footer.component";
import {EditDivDirectiveModal} from "./directives/modal.directive";
import {PreLoaderComponent} from './pre-loader/pre-loader.component';
import {RulesComponent} from './rules/rules.component';
import {AuthorizationComponentComponent} from './authorization-component/authorization-component.component';
import {HeaderComponent} from "./header/header.component";
import {ProlongationComponent} from './prolongation/prolongation.component';
import {FiliationComponent} from './filiation/filiation.component';

import {EditSuccessDirective} from "./directives/success.directive";
import {EditFailDirective} from "./directives/fail.directive";

import {locale, loadMessages} from 'devextreme/localization';
import {DxDataGridModule} from 'devextreme-angular';
import 'devextreme-intl';

import {DecimalDirective} from './directives/decimal.directive';
import { RegistrationComponent } from './registration/registration.component';
import {PersonalCabinetComponent} from "./personal-cabinet/personal-cabinet.component";
import {PersonalCabinetGuard} from "./PersonalCabinetGuard";
import { PayorderComponent } from './payorder/payorder.component';
import {LoggerComponent} from "./logger/logger.component";
import {ConfigComponent} from "./config/config.component";
import {LoggerService} from "./services/logger.service";
import { QrComponent } from './qr/qr.component';
import {MaintenanceComponent} from './maintenance/maintenance.component';
import {MaintenanceGuard} from './MaintenanceGuard';
import {MaintenanceService} from './services/maintenance.service';


export function recaptchaLoader() {
  return new RecaptchaLoaderService("uk")
};

let messagesUk = require("./../uk.json");
loadMessages(messagesUk);
locale("uk");

@NgModule({
  declarations: [
    EditDivDirective,
    EditDivDirectiveFooter,
    EditDivDirectiveModal,
    EditSuccessDirective,
    EditFailDirective,
    AppComponent,
    LoginComponent,
    OrderComponent,
    AdminComponent,
    AdminLogin,
    FooterComponent,
    paymentSuccess,
    paymentFailure,
    ConfirmDialog,
    PreLoaderComponent,
    RulesComponent,
    AuthorizationComponentComponent,
    TableDialogComponent,
    PayDialogComponent,
    HeaderComponent,
    SafeHtmlPipe,
    ProlongationComponent,
    FiliationComponent,
    DecimalDirective,
    RegistrationComponent,
    PersonalCabinetComponent,
    PayorderComponent,
    LoggerComponent,
    ConfigComponent,
    QrComponent,
    MaintenanceComponent,
  ],

  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    RouterModule.forRoot(appRoutes),
    AlertModule,
    NgIdleKeepaliveModule.forRoot(),
    RecaptchaModule.forRoot(),
    MaterialModule,
    MomentModule,
    ToastModule,
    FlexLayoutModule,
    DxDataGridModule,
    ReactiveFormsModule
  ],

  entryComponents: [TableDialogComponent, PayDialogComponent],
  providers: [DataService, LoginService, EditDataService, LoggerService, Guard, AdminService, ToastModule, PersonalCabinetGuard,
    MaintenanceService, MaintenanceGuard,
    {
      provide: RecaptchaLoaderService,
      useFactory:  recaptchaLoader
    }]
  ,
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /home/backend/NasheDelo/WebLombard/client/src/app/app.module.ts